$ ->
  class AnalyticsLessonView
    constructor: ->
      @bindToggle()

    updateParams: (includeBlanks) ->
      @includeBlanks = includeBlanks
      $('#lesson-views .sorter a').attr "href", (i, href) =>
        href.replace(/include_blank.*?&/g, "include_blank=#{@includeBlanks}&")

    bindToggle: ->
      $('#content').on 'click', '#include-blank', =>
        console.log 'clicked'
        @updateParams($('#include-blank').prop('checked'))

  if $('.admin').length
    new AnalyticsLessonView()
